import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { useFeatureToggle } from '@flopflip/react-redux';
import { Box, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';

import { IconSize } from 'constants/coreDesignSystem';
import { FeatureFlag } from 'constants/featureFlags';

import { selectSelectedOtherPendingChangesAuthors } from 'store/loanApplications/selectors/pendingChangesAuthors.selectors';
import {
  selectIsCurrentUserPendingChangesAuthorSelected,
  selectPendingChangesAuthorsHeaderValue,
} from 'store/loanApplications/selectors/pendingChangesAuthorsSelection.selectors';

import { noticeIconStyles, noticeStyles } from './PendingChangesAuthorsNotice.styles';
import { PendingChangesAuthorsNoticeTestIds } from './PendingChangesAuthorsNotice.testIds';
import { getPendingChangesAuthorsNotice } from './PendingChangesAuthorsNotice.utils';

const PendingChangesAuthorsNotice = () => {
  const isPendingChangesByUserEnabled = useFeatureToggle(FeatureFlag.PendingChangesByUser);

  const selectedOtherAuthors = useSelector(selectSelectedOtherPendingChangesAuthors);
  const isCurrentUserSelected = useSelector(selectIsCurrentUserPendingChangesAuthorSelected);
  const headerValue = useSelector(selectPendingChangesAuthorsHeaderValue);

  const notice = getPendingChangesAuthorsNotice({ selectedOtherAuthors, isCurrentUserSelected });

  if (!isPendingChangesByUserEnabled || !headerValue || !notice) {
    return null;
  }

  return (
    <Box data-testid={PendingChangesAuthorsNoticeTestIds.NOTICE} sx={noticeStyles}>
      <Box sx={noticeIconStyles}>
        <InfoIcon size={IconSize[16]} />
      </Box>
      <Typography color="text.secondary" variant="regular12">
        {notice}
      </Typography>
    </Box>
  );
};

export default memo(PendingChangesAuthorsNotice);
